<tt-page>
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-select ttLabel="product" [(ttModel)]="productId" [ttData]="selectListProducts" (ttModelChange)="onProductChanged($event)" ttDataId="prod_id" ttDataName="prod_name"></tt-select>

            <div [hidden]="productId === ''">
                <ng-container *ngTemplateOutlet="recalculatePrices"></ng-container>

                <div [hidden]="inputListPrices.length === 0">
                    <ng-container *ngTemplateOutlet="previewPrices"></ng-container>
                </div>
            </div>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="special_cust_prod_calc_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="35">
                    <tt-card class="col-xs-12 p-5">
                        <tt-select ttLabel="product" [(ttModel)]="productId" [ttData]="selectListProducts" (ttModelChange)="onProductChanged($event)" ttDataId="prod_id" ttDataName="prod_name"></tt-select>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5" [hidden]="productId === ''">
                        <ng-container *ngTemplateOutlet="recalculatePrices"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="35">
                    <tt-card class="col-xs-12 p-5" [hidden]="productId === '' && inputListPrices.length === 0">
                        <ng-container *ngTemplateOutlet="previewPrices"></ng-container>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #recalculatePrices>
    <ng-container *ngIf="!!calculation">
        <tt-input ttLabel="price" [ttModel]="calculation.price" ttReadonly></tt-input>
        <tt-input-number ttLabel="discount" [(ttModel)]="calculation.discount" (ttOnBlur)="onCalculationBlur('discount')" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="sold_freight" [(ttModel)]="calculation.sold_freight" (ttOnBlur)="onCalculationBlur('sold_freight')" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="postplace_id" [(ttModel)]="calculation.postplace_id" (ttOnBlur)="onCalculationBlur('postplace_id')" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
    </ng-container>
</ng-template>

<ng-template #previewPrices>
    <ng-container *ngIf="!!calculation">
        <label *ngIf="calculation.price_pr_kg_label > ''" class="checklist-h1e col-xs-12">{{calculation.price_pr_kg_label}}</label>
        <tt-input-number *ngFor="let item of inputListPrices" [ttLabel]="item.company_name" [ttModel]="item.price_pr_kilo" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
    </ng-container>
</ng-template>
